import Swiper from 'swiper';
import {EffectFade, Navigation, Thumbs, Pagination, FreeMode} from 'swiper/modules';

class ProductGallery {
    constructor() {
        this.gallery = document.querySelectorAll('.js-product-gallery');
    }

    init() {
        if (this.gallery.length > 0) {
            this.gallery.forEach((el) => {
                const identifier = el.dataset.identifier;
                const swiperElements = el.querySelectorAll('.swiper');

                if (swiperElements.length === 2) {
                    const swiperThumbs = new Swiper(swiperElements[1], {
                        direction: "vertical",
                        spaceBetween: 10,
                        slidesPerView: 4,
                        freeMode: true,
                        watchSlidesProgress: true,
                        navigation: {
                            nextEl: el.querySelector('.slider-next-' + identifier),
                            prevEl: el.querySelector('.slider-prev-' + identifier),
                        },
                        modules: [Navigation, Pagination, FreeMode]
                    });

                    const swiperGallery = new Swiper(swiperElements[0], {
                        effect: "fade",
                        navigation: {
                            nextEl: el.querySelector('.slider-next-' + identifier),
                            prevEl: el.querySelector('.slider-prev-' + identifier),
                        },
                        modules: [EffectFade, Navigation, Thumbs],
                        thumbs: {
                            swiper: swiperThumbs,
                        }
                    });
                }
            });

            // update swiper on tab change
            document.addEventListener('tab-changed', (e) => {
                e.detail.tab.querySelectorAll('.swiper').forEach((el) => {
                    el.swiper.update();
                });
            });
        }
    }
}

export default new ProductGallery();
